export default {"src":"/_next/static/media/email-logo.4a5419ed.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};